// import { globalPut } from '../index';
import { post } from "../index";

export const uploadCsv = body => {
  console.log(body)
  return post('/milestones/csv', body, true);
}
